import React, { useEffect, useState } from 'react'
import styles from './LoginInformation.module.css'
import { FormTitle } from '../../../Common/FormTitle'
import { NextButton } from '../../../Common/CtaButton/NextButton'
import { FormField } from '../../../Common/FormField'
import { validateForm } from './validate'
import { HandleBlurFunction } from './types'
import { useAbTestGtm } from '../../../../hooks/useAbTestGtm'

export const LoginInformation = () => {
    const { dataClickLabel, dataViewLabel } = useAbTestGtm()
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [isFormValid, setIsFormValid] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const [errors, setErrors] = useState({
        email: '',
        password: '',
    })
    const [touched, setTouched] = useState({
        email: false,
        password: false,
    })

    useEffect(() => {
        const validateAndSetState = async () => {
            const { errors: validationErrors, isValid } = await validateForm(
                email,
                password,
                touched
            )
            setErrors(validationErrors)
            setIsFormValid(isValid)
        }

        validateAndSetState()
    }, [email, password, touched])

    const handleBlur: HandleBlurFunction = field => {
        setTouched(prev => ({
            ...prev,
            [field]: true,
        }))
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.selectionWrapper}>
                <div className={styles.monthbox}>
                    <FormTitle
                        formTitleText='メールアドレスとパスワードを決めましょう'
                        dataViewLabel={dataViewLabel('EF_StepForm_メールアドレス')}
                        dataClickLabel={dataClickLabel('EF_StepForm_メールアドレス-戻る')}
                    />
                </div>
                <p className={styles.announce}>
                    応募・問い合わせには登録が必要です
                </p>
                <div className={styles.mailField}>
                    <FormField
                        label='メールアドレス'
                        placeholder='メールアドレスを入力(ログインID)'
                        value={email}
                        onBlur={() => handleBlur('email')}
                        onChange={setEmail}
                    />
                    {errors.email && (
                        <p className={styles.errorMessages}>{errors.email}</p>
                    )}
                </div>
                <div className={styles.passField}>
                    <div>
                        <FormField
                            label='パスワード'
                            placeholder='パスワード：大小英数字含む8文字以上'
                            value={password}
                            onChange={setPassword}
                            onBlur={() => handleBlur('password')}
                            isInputType={showPassword ? 'text' : 'password'}
                        />
                        <div>
                            <label className={styles.customCheckbox}>
                                パスワードを表示
                                <input
                                    type='checkbox'
                                    onChange={e =>
                                        setShowPassword(e.target.checked)
                                    }
                                />
                                <span className={styles.checkMark}></span>
                            </label>
                        </div>
                        {errors.password && (
                            <p className={styles.errorMessages}>
                                {errors.password}
                            </p>
                        )}
                        <div className={styles.validationHintWrap}>
                            <img
                                src={'/foodslaboEf/img/step8/lightIcon.svg'}
                                alt={'電球アイコン'}
                            />
                            <p className={styles.validationHint}>
                                パスワードは最低8文字以上です。大小英数字は含まれていますか？
                            </p>
                        </div>
                        <p className={styles.loginText}>
                            <a
                                href={'/login'}
                                data-click-label={dataClickLabel('EF_StepForm_メールアドレス-会員登録済み')}
                            >
                                会員登録済みの方はこちら
                            </a>
                        </p>
                    </div>
                </div>
                <NextButton
                    formKey={['email', 'password']}
                    formValue={[email, password]}
                    displayFormKey={['email', 'password']}
                    displayFormValue={[email, password]}
                    isDisabled={!isFormValid}
                    dataClickLabel={dataClickLabel('EF_StepForm_メールアドレス-次へ')}
                />
            </div>
        </div>
    )
}
